// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalButtonsActionStyles, xScreen } from "@eisinc/XDL/Utilities";
import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 16px;
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            > button {
                flex: 1;
            }
        }
    `,
};

orderUploadErrorsModalStyles.cancelUploadButton = { ...modalButtonsActionStyles.cancelButton };

orderUploadErrorsModalStyles.continueUploadButton = { ...modalButtonsActionStyles.submitButton };
